const state = {
  snackbarVisible: false,
  snackbarTitle: 'hello',
  snackbarTimeout: 4000,
  snackbarColor: '#f44336'
};

const getters = {
  snackbarVisible: state => {
    return state.snackbarVisible;
  },
  snackbarTitle: state => {
    return state.snackbarTitle;
  },
  snackbarTimeout: state => {
    return state.snackbarTimeout;
  },
  snackbarColor: state => {
    return state.snackbarColor;
  }
};

const mutations = {
  setTitleAndStartSnackbar: (state, valueTitle) => {
    state.snackbarTitle = valueTitle;
    state.snackbarVisible = true;
  },
  setTitleAndStartSnackbarWithTimeout: (state, valueTitle) => {
    console.log('yes');
    state.snackbarTitle = valueTitle;
    setTimeout(() => {
      state.snackbarVisible = true;
    }, 500);
  },
  setSnackbarVisible: (state, value) => {
    state.snackbarVisible = value;
  },
  setSnackbarTitle: (state, value) => {
    state.snackbarTitle = value;
  },
  setSnackbarTimeout: (state, value) => {
    state.snackbarTimeout = value;
  },
  setSnackbarColor: (state, value) => {
    state.snackbarColor = value;
  }
};

export default {
  state,
  getters,
  mutations
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/snackbar.js
// module id = null
// module chunks = 